import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20 pb-20 flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-6">
          <i className="ri-error-warning-line text-3xl"></i>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
          页面未找到
        </h1>
        <p className="text-foreground-600 mb-6 max-w-md">
          您访问的页面不存在或已被移除。请检查链接是否正确，或返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="px-6 py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
      <Footer />
    </div>
  );
}